import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { deepMerge } from '../utils/objects';
import { substitute } from '../utils/strings';
import { getLocale } from '../locale';

var createMessage = function createMessage(key) {
  return function (props) {
    var lt = '';

    switch (props.type) {
      case 'integer':
      case 'number':
        lt = 'number';
        break;

      case 'array':
        lt = 'array';
        break;

      default:
        lt = 'string';
    }

    return substitute(getLocale("rules.length.".concat(key, ".").concat(lt)), props);
  };
};

var options = {
  skipUndefined: true
};
export var lengthMessage = {
  max: createMessage('max'),
  min: createMessage('min')
};
export default (function (key) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      message = _ref.message;

  return function (len, msg) {
    if (typeof len !== 'number') {
      console.error(new Error("Rule \"".concat(key, "\" param expect a number, get ").concat(typeof len)));
      return null;
    }

    return deepMerge({
      message: lengthMessage[key]
    }, deepMerge(_defineProperty({
      message: message
    }, key, len), {
      message: msg
    }, options), options);
  };
});